const jobStatuses = {
    Queued: 1,
    Processing: 2,
    Failed: 3,
    Succeeded: 4
}

const jobStatusNames = {
    [jobStatuses.Queued]: "Queued",
    [jobStatuses.Processing]: "Processing",
    [jobStatuses.Failed]: "Failed",
    [jobStatuses.Succeeded]: "Succeeded",
}

export class JobStatus {
    constructor(jobStatus) {
        this.jobStatus = jobStatus;
        this.text = jobStatusNames[this.jobStatus];
    }
}

JobStatus.Queued = new JobStatus(jobStatuses.Queued);
JobStatus.Processing = new JobStatus(jobStatuses.Processing);
JobStatus.Failed = new JobStatus(jobStatuses.Failed);
JobStatus.Succeeded = new JobStatus(jobStatuses.Succeeded);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Queued = JobStatus.Queued;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Processing = JobStatus.Processing;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Failed = JobStatus.Failed;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Succeeded = JobStatus.Succeeded;
